import { render } from "./NomenclatoareParcAuto.vue?vue&type=template&id=3ee8f16a&scoped=true&ts=true"
import script from "./NomenclatoareParcAuto.vue?vue&type=script&lang=ts"
export * from "./NomenclatoareParcAuto.vue?vue&type=script&lang=ts"

import "./NomenclatoareParcAuto.vue?vue&type=style&index=0&id=3ee8f16a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee8f16a"]])

export default __exports__